import { makeStyles } from '@material-ui/core';
import { CheckCircle, RadioButtonChecked, RadioButtonUnchecked } from '@material-ui/icons';
import clsx from 'clsx';
import React from 'react';
import { theme } from '../../theme/theme';

const useStepperClasses = makeStyles({
    root: {
        display: 'flex',
        ...theme.typography.content.label.default,
        textTransform: 'capitalize',
    },
    step: {
        display: 'flex',
        alignItems: 'center',
        flex: '1 0 100px',
        padding: '10px 0',
        borderTop: '2px solid currentColor',
        margin: '0 5px',
        transition: `color ${theme.transitions.default}s`,
        '&.completed': {
            color: theme.colors.neutral[2],
        },
        '&.current': {
            color: theme.colors.green[4],
        },
        '&.remaining': {
            color: theme.colors.neutral[3],
        },
        '& > svg': {
            marginRight: 5,
        },
    },
});

/**
 * Global stepper component.
 *
 * @param props.labels list of labels to be displayed in the stepper
 * @param props.current current stepper label
 */
export const Stepper = (props: JSX.IntrinsicElements['div'] & { labels: string[]; current: string }) => {
    const { labels, current, ...rootProps } = props;
    const classes = useStepperClasses();
    const index = labels.indexOf(current);
    const icons = { completed: <CheckCircle />, current: <RadioButtonChecked />, remaining: <RadioButtonUnchecked /> };

    return (
        <div {...rootProps} className={clsx(classes.root, rootProps.className)}>
            {labels.map((label, i) => {
                const status = i < index ? 'completed' : i > index ? 'remaining' : 'current';
                return (
                    <span key={i} className={clsx(classes.step, status)}>
                        {icons[status]}
                        {label}
                    </span>
                );
            })}
        </div>
    );
};
